var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 154,
    viewBox: "0 0 181 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.3159 70.0126C76.6265 64.7991 83.0212 62.1923 90.5 62.1923C97.9788 62.1923 104.374 64.7991 109.684 70.0126C114.995 75.2262 117.65 81.504 117.65 88.8462C117.65 96.1883 114.995 102.466 109.684 107.68C104.374 112.893 97.9788 115.5 90.5 115.5C83.0212 115.5 76.6265 112.893 71.3159 107.68C66.0053 102.466 63.35 96.1883 63.35 88.8462C63.35 81.504 66.0053 75.2262 71.3159 70.0126ZM135.75 23.6923H156.867C163.528 23.6923 169.216 26.006 173.93 30.6334C178.643 35.2608 181 40.8446 181 47.3846V130.308C181 136.848 178.643 142.431 173.93 147.059C169.216 151.686 163.528 154 156.867 154H24.1333C17.4715 154 11.7839 151.686 7.07031 147.059C2.35677 142.431 0 136.848 0 130.308V47.3846C0 40.8446 2.35677 35.2608 7.07031 30.6334C11.7839 26.006 17.4715 23.6923 24.1333 23.6923H45.25L50.0578 11.1058C51.2519 8.08253 53.4359 5.47576 56.6096 3.28546C59.7834 1.09515 63.0358 0 66.3667 0H114.633C117.964 0 121.217 1.09515 124.39 3.28546C127.564 5.47576 129.748 8.08253 130.942 11.1058L135.75 23.6923ZM60.6633 118.138C68.9277 126.251 78.8733 130.308 90.5 130.308C102.127 130.308 112.072 126.251 120.337 118.138C128.601 110.024 132.733 100.26 132.733 88.8462C132.733 77.4319 128.601 67.6681 120.337 59.5547C112.072 51.4413 102.127 47.3846 90.5 47.3846C78.8733 47.3846 68.9277 51.4413 60.6633 59.5547C52.3989 67.6681 48.2667 77.4319 48.2667 88.8462C48.2667 100.26 52.3989 110.024 60.6633 118.138Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 154,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ab755d32da78ad918486fef2a94dada5.svg";
export { ForwardRef as ReactComponent };